import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Timestamp } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
export function conversationHistorySubTitleRenderer(params) {
    const { metaConversation } = params;
    const { conversation } = metaConversation;
    const { last_message_created_at: lastMessageCreatedAt, queue } = conversation;
    const separator = ' · ';
    const CSID = metaConversation.conversation.id;
    return (_jsxs(_Fragment, { children: [CSID && _jsx("span", { children: `#${CSID}` }), lastMessageCreatedAt && (_jsxs(_Fragment, { children: [separator, _jsx("span", Object.assign({ onClick: () => analytics.conversationsTimestampClicked({
                            context: 'created',
                        }) }, { children: _jsx(Timestamp, { relative: true, time: lastMessageCreatedAt }) }))] })), queue && (_jsxs(_Fragment, { children: [_jsx("span", { children: separator }), _jsx("span", { children: queue.name })] }))] }));
}
